import {Translator} from "./ai-assistent/translator";
import {Requests} from "./ai-assistent/requests";

function initializeCompassAssistent() {
    const assistent = document.getElementById('compass-assistent');

    if (!assistent) {
        window.compassAssistent = null;
        return;
    }


    /**
     * Properties
     * */
    assistent.actionChoice = null;
    assistent.actionChoices = {
        translator: 'translator',
        rewriter: 'rewriter',
        spellcheck: 'spellcheck'
    };
    assistent.stepElements = {
        /** Choices/Start */
        choices: assistent.querySelector('.compass-assistent-action-choices'),

        /** Actions */
        translator_action: assistent.querySelector('.compass-assistent-translator-action'),
        rewriter_action: assistent.querySelector('.compass-assistent-rewriter-action'),
        spellcheck_action: assistent.querySelector('.compass-assistent-spellcheck-action'),

        /** Processing */
        processing: assistent.querySelector('.compass-assistent-processing'),

        /** Responses */
        translator_response: assistent.querySelector('.compass-assistent-translator-response'),
        rewriter_response: assistent.querySelector('.compass-assistent-rewriter-response'),
        spellcheck_response: assistent.querySelector('.compass-assistent-spellcheck-response')
    };

    /**
     * Modules
     * */
    assistent.requests = new Requests(assistent);
    assistent.translator = new Translator(assistent);
    assistent.requests.loadConfiguration();

    /**
     * Functions
     * */
    assistent.isVisible = function () {
        return !assistent.classList.contains('d-none');
    }

// close on click on ::after backdrop
    assistent.addEventListener('click', function (e) {
        // can you get the start point of the click?

        if (e.target === assistent) {
            assistent.classList.add('d-none');
        }
    });

    assistent.setActiveStep = function (step) {
        assistent.querySelector('.compass-assistent-step.active')?.classList.remove('active');
        step.classList.add('active');
    }

    assistent.close = function () {
        assistent.classList.add('d-none');
    }

    /** Make globally accessible */
    window.compassAssistent = assistent;
}
initializeCompassAssistent();